var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.779297,
    y: 0.5,
    width: 25.0076,
    height: 25,
    rx: 12.5,
    fill: "#456786"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_5049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2832 14.25C14.2497 14.25 15.0332 13.4665 15.0332 12.5C15.0332 11.5335 14.2497 10.75 13.2832 10.75C12.3167 10.75 11.5332 11.5335 11.5332 12.5C11.5332 13.4665 12.3167 14.25 13.2832 14.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8193 12.3512C19.3047 11.0202 18.4114 9.86914 17.2497 9.04029C16.0881 8.21143 14.709 7.74113 13.283 7.6875C11.857 7.74113 10.4779 8.21143 9.31629 9.04029C8.15465 9.86914 7.26134 11.0202 6.74677 12.3512C6.71202 12.4474 6.71202 12.5526 6.74677 12.6488C7.26134 13.9798 8.15465 15.1309 9.31629 15.9597C10.4779 16.7886 11.857 17.2589 13.283 17.3125C14.709 17.2589 16.0881 16.7886 17.2497 15.9597C18.4114 15.1309 19.3047 13.9798 19.8193 12.6488C19.854 12.5526 19.854 12.4474 19.8193 12.3512ZM13.283 15.3438C12.7206 15.3438 12.1708 15.177 11.7031 14.8645C11.2355 14.552 10.871 14.1079 10.6557 13.5883C10.4405 13.0686 10.3842 12.4968 10.4939 11.9452C10.6036 11.3936 10.8745 10.8869 11.2722 10.4892C11.6699 10.0915 12.1766 9.82062 12.7282 9.71089C13.2799 9.60117 13.8516 9.65748 14.3713 9.87272C14.8909 10.088 15.335 10.4524 15.6475 10.9201C15.96 11.3877 16.1268 11.9376 16.1268 12.5C16.1256 13.2539 15.8256 13.9765 15.2926 14.5096C14.7595 15.0426 14.0369 15.3426 13.283 15.3438Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_5049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6.2832 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e189678ffe58172e1b3f6d2a93f818f1.svg";
export { ForwardRef as ReactComponent };